import React from 'react';
import 'src/components/Loader/Loader.scss';

// https://projects.lukehaas.me/css-loaders/

const Loader = () => {
  return <div className="Loader"></div>;
};

export default Loader;
